/**
 * Push Notification Settings Component (Hub)
 *
 * Zeigt in den Einstellungen:
 *   - Status (aktiv/inaktiv/nicht unterstuetzt)
 *   - Aktivieren/Deaktivieren Toggle
 *   - Test-Notification Button
 */
import { Bell, BellOff, Send } from "lucide-react";
import { usePushNotifications } from "../hooks/usePushNotifications";

export function PushNotificationSettings() {
  const { supported, permission, subscribed, loading, enabled, subscribe, unsubscribe, sendTest } =
    usePushNotifications();

  if (!supported) {
    return (
      <div className="flex items-center gap-3 text-sm text-[var(--text-muted)]">
        <BellOff size={16} />
        <span>Push-Benachrichtigungen werden von diesem Browser nicht unterstützt.</span>
      </div>
    );
  }

  if (!enabled) {
    return (
      <div className="flex items-center gap-3 text-sm text-[var(--text-muted)]">
        <BellOff size={16} />
        <span>Push-Benachrichtigungen sind serverseitig nicht konfiguriert (VAPID Keys fehlen).</span>
      </div>
    );
  }

  if (permission === "denied") {
    return (
      <div className="flex items-center gap-3 text-sm text-[var(--text-muted)]">
        <BellOff size={16} />
        <span>
          Benachrichtigungen wurden im Browser blockiert. Bitte in den Browser-Einstellungen
          erlauben.
        </span>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Bell size={16} className={subscribed ? "text-[var(--accent)]" : "text-[var(--text-muted)]"} />
          <div>
            <p className="text-sm font-medium">
              {subscribed ? "Push-Benachrichtigungen aktiv" : "Push-Benachrichtigungen inaktiv"}
            </p>
            <p className="text-xs text-[var(--text-muted)]">
              Downtime-Alerts, UltraReview-Status, Entscheidungen
            </p>
          </div>
        </div>

        <button
          onClick={() => (subscribed ? unsubscribe() : subscribe())}
          disabled={loading}
          className={`px-3 py-1.5 text-xs font-medium rounded transition-colors ${
            subscribed
              ? "bg-red-500/10 text-red-400 hover:bg-red-500/20"
              : "bg-[var(--accent)]/10 text-[var(--accent)] hover:bg-[var(--accent)]/20"
          } disabled:opacity-50`}
        >
          {loading ? "..." : subscribed ? "Deaktivieren" : "Aktivieren"}
        </button>
      </div>

      {subscribed && (
        <button
          onClick={sendTest}
          className="flex items-center gap-2 px-3 py-1.5 text-xs text-[var(--text-muted)] hover:text-[var(--text)] border border-[var(--border)] rounded transition-colors"
        >
          <Send size={12} />
          Test-Benachrichtigung senden
        </button>
      )}
    </div>
  );
}
